module.exports = __webpack_public_path__ + "img/bh_15.477014cf.jpg";